"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonLink = void 0;
const react_1 = __importStar(require("react"));
const primary_1 = require("../common/styles/primary");
const secondary_1 = require("../common/styles/secondary");
const tertiary_1 = require("../common/styles/tertiary");
const quaternary_1 = require("../common/styles/quaternary");
const flat_1 = require("../common/styles/flat");
const floating_primary_1 = require("../common/styles/floating-primary");
const ghost_1 = require("../common/styles/ghost");
const contrast_1 = require("../common/styles/contrast");
exports.ButtonLink = (0, react_1.forwardRef)((_a, ref) => {
    var { mode = 'secondary', children } = _a, props = __rest(_a, ["mode", "children"]);
    switch (mode) {
        case 'primary':
            return (react_1.default.createElement(primary_1.PrimaryButtonLink, Object.assign({}, props, { ref: ref }), children));
        case 'tertiary':
            return (react_1.default.createElement(tertiary_1.TertiaryButtonLink, Object.assign({}, props, { ref: ref }), children));
        case 'quaternary':
            return (react_1.default.createElement(quaternary_1.QuaternaryButtonLink, Object.assign({}, props, { ref: ref }), children));
        case 'flat':
            return (react_1.default.createElement(flat_1.FlatButtonLink, Object.assign({}, props, { ref: ref }), children));
        case 'ghost':
            return (react_1.default.createElement(ghost_1.GhostButtonLink, Object.assign({}, props, { ref: ref }), children));
        case 'contrast':
            return (react_1.default.createElement(contrast_1.ContrastButtonLink, Object.assign({}, props, { ref: ref }), children));
        case 'floating-primary':
            return (react_1.default.createElement(floating_primary_1.FloatingPrimaryButtonLink, Object.assign({}, props, { ref: ref }), children));
        case 'secondary':
        default:
            return (react_1.default.createElement(secondary_1.SecondaryButtonLink, Object.assign({}, props, { ref: ref }), children));
    }
});
exports.ButtonLink.displayName = 'ButtonLink';
//# sourceMappingURL=ButtonLink.js.map